import React, {Component} from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import ListingContainer from "../../containers/listing_container";
import DashboardContainer from "../../containers/dashboard_container";
import FilterAttributes from "../../containers/filter_container";
import { CUSTOMER_SERVICE_API_URL } from "../../constants/api_routes";
import ViewQueryDetail from './view_query_detail';
import EditQueryDetail from "./edit_query_detail"
import { Button, Form, Header, Icon, Modal, Popup, Grid } from "semantic-ui-react";
import Loader from "../universal/loader";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {formatDate, parseDate} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import moment from 'moment';
import {BASE_URL, CUSTOM_REPORT} from "../../constants/app_routes";
import {handleFileDownload} from "../../utils/download_file";
import DownloadingIntent from "../universal/toast";
import {getCustomerServiceQueriesForInspection} from '../../data/dashboard_api';

class CustomerService extends Component {
    constructor(props) {
        super(props);
        this.state = {
            action: 'listing',
            showConfirm: false,
            dropdownValue: '',
            selectedInspectionDate: undefined,
            fromDate: undefined,
            toDate: undefined,
            dateFiltered: false,
            inspectionId: undefined,
            currentAssignedUser: undefined,
            isDownloading: false,
            selectiveQueries: false,
            refreshingQuery:false
        };
    }

    componentWillMount() {
        this.setState({action: 'listing'});
        if (this.props.startDate && this.props.endDate) {
            this.setState({dateFiltered: true, fromDate: this.props.startDate, toDate: this.props.endDate});
        }
    }

    handleView = (query,queryAddress) => {
        this.setState({action: 'view', query:query, queryAddress:queryAddress});
    };

    handleEdit = (query, queryAddress) => {
        this.setState({action: 'edit', query:query, queryAddress:queryAddress});
    };
    refreshData = async () => {
        this.setState({ action: "listing", isFetching: true, isListFetching: true, isLoadingRefresh:true,refreshingQuery:false });
        if(this.state.fromDate && this.state.toDate){
            this.props.getDashboardData(moment().add('-1', "month").startOf('month').format("DD-MM-YYYY"), moment().add('2', "month").endOf('month').format("DD-MM-YYYY"))
            this.props.getCustomerServiceByDate(CUSTOMER_SERVICE_API_URL, this.state.fromDate, this.state.toDate).then(() => { this.setState({ isLoadingRefresh: false })});
        }
        else {
            this.props.getDashboardData(moment().add('-1', "month").startOf('month').format("DD-MM-YYYY"), moment().add('2', "month").endOf('month').format("DD-MM-YYYY"))
            this.props.getList(CUSTOMER_SERVICE_API_URL).then(() => { this.setState({ isLoadingRefresh: false })})
        }
    }


     refreshQueryData = async () => {
        console.log(this.state.query)
        this.setState({ refreshingQuery: true})
         const response = await getCustomerServiceQueriesForInspection(this.state.query.inspection_id)
         console.log(response)
         const matchingQuery = response.find(
  q => q.id === this.state.query.id
);
        this.setState({ query: matchingQuery,refreshingQuery:false })
        }
    handleDownload = async (id, reportDetail) => {
        this.setState({isDownloading: true, showDownload: true});
        let URL = BASE_URL + "/report/download/" + id;
        //if(reportDetail['report_pdf_path']){
        //    URL = reportDetail['report_pdf_path'];
        //}
        let fileName = reportDetail;
        await handleFileDownload(URL, fileName,);
        this.setState({isDownloading: false});
    };
    exportQueries = async (type) => {
        this.setState({isDownloading:true,showDownload:true});
        let URL = BASE_URL+"/export/customer_service";
        let fileName = "Customer Service List.xlsx";
        if(this.state.dateFiltered && this.state.fromDate && this.state.toDate){
            fileName = "Customer Service List -" + moment(this.state.fromDate).format("DD-MM-YYYY") + "-" + moment(this.state.toDate).format("DD-MM-YYYY") + " .xlsx";
            if (type == 1) {
                URL = BASE_URL + "/export/customer_service?start_date=" + this.state.fromDate + "&end_date=" + this.state.toDate;
            }
            else if (type == 2) {
                URL = BASE_URL + "/export/customer_service_by_inspection?start_date=" + this.state.fromDate + "&end_date=" + this.state.toDate;
            }
        }
        await handleFileDownload(URL,fileName,'application/xlsx');
        this.setState({isDownloading:false});
    };

    componentWillUnmount() {
        this.props.setFilter(undefined, undefined, undefined , undefined);
    }

    handleFilterSelection = () => {
        this.setState({dateFiltered: true, isLoadingRefresh:true});
        if(this.state.fromDate && this.state.toDate){
            this.props.getCustomerServiceByDate(CUSTOMER_SERVICE_API_URL, this.state.fromDate, this.state.toDate).then(() => {this.setState({isLoadingRefresh:false})});
        }
    };

    handleStatusChangeDate = (CSDate) => {
        var newCSDate = moment(CSDate, "YYYY-MM-DD HH:mm Z").format("DD-MM-YYYY")
        this.setState({dateFiltered: true, fromDate:newCSDate,toDate:newCSDate});
    };

    render() {
        const csStatus = {
            "pending": 'Pending',
            "awaiting_admin_review": 'Awaiting Admin Review',
            "awaiting_clerk_reply": 'Awaiting Clerk Reply',
            "closed": 'Closed'
        };
        const csType = {
            "comment": 'Comment',
            "query": 'Query'
        };
        const csValid = {
            "true": 'Yes',
            "false": 'No'
        };
        const columns = [{
            Header: 'Date Submitted',
            id: 'date_submitted',
            accessor: 'created_at',
            className: 'date-width',
            headerClassName: 'date-width',
            maxWidth:125,
            filterable: true,
            filterMethod: (filter, row) => {
                const id = filter.pivotId || filter.id;
                return row[id] !== undefined ? moment(row[id], "YYYY-MM-DD HH:mm Z").format("DD:MM:YYYY").toUpperCase().indexOf(filter.value.toUpperCase()) >= 0 : true
            },
            Cell: ({original, value}) => (

                <span>{moment(original['created_at'], "YYYY-MM-DD HH:mm Z").format("DD-MM-YYYY")}</span>
            )
        },
        {
            Header: 'Date Of Job',
            id: 'date_of_job',
            accessor: d=> d.inspection.inspection_start_time,
            className: 'date-width',
            headerClassName: 'date-width',
            maxWidth:125,
            filterable: true,
            filterMethod: (filter, row) => {
                const id = filter.pivotId || filter.id;
                return row[id] !== undefined ? moment(row[id], "YYYY-MM-DD HH:mm Z").format("DD:MM:YYYY").toUpperCase().indexOf(filter.value.toUpperCase()) >= 0 : true
            },
            Cell: ({original, value}) => (

                <span>{moment(original.inspection['inspection_start_time'], "YYYY-MM-DD HH:mm Z").format("DD-MM-YYYY")}</span>
            )
        }, {
            Header: 'Company',
            accessor: d => d.inspection.company_name,
            id: 'company_name',
            filterable: true,
            className: 'left-aligned',
            maxWidth:"200",
            filterMethod: (filter, row) => {
                const id = filter.pivotId || filter.id;
                return row[id] !== undefined ? String(row[id]).replace(/[^\w]/g,'').toUpperCase().indexOf(filter.value.replace(/[^\w]/g,'').toUpperCase()) >= 0 : true
            }
        }, {
            Header: 'Address',
            id: 'property',
            className: 'left-aligned',
            accessor: d => d.property['address'],
            filterMethod: (filter, row) => {
                const id = filter.pivotId || filter.id;
                return row[id] !== undefined ? String(row[id]).replace(/[^\w]/g,'').toUpperCase().indexOf(filter.value.replace(/[^\w]/g,'').toUpperCase()) >= 0 : true
            },
            filterable: true,
            Cell: ({original, value}) => (
                <div>
                    <Popup
                        trigger={<span>{value}</span>}
                        content={<div style={{paddingTop: '5px'}}>
                            <span>{value}</span>
                        </div>}
                        position='top left'
                        on='hover'
                        wide
                        header='Inspection Address'
                        hideOnScroll
                    /></div>
            )
        }, {
            Header: 'Job type',
            accessor: d => d.inspection.inspection_type,
            id: 'inspection_type',
            className: 'formatcase mini-width',
            headerClassName: 'mini-width dropdown-overlay',
            maxWidth:75,
            filterable: true,
            filterMethod: (filter, row) => {
                if (filter.value === "ci") {
                    return row[filter.id] === 'ci';
                }
                if (filter.value === "co") {
                    return row[filter.id] === 'co';
                }
                if (filter.value === "inv") {
                    return row[filter.id] === 'inv';
                }
                if (filter.value === "inv/ci") {
                    return row[filter.id] === 'inv/ci';
                }
                return true;
            },
            Filter: ({filter, onChange}) =>
                <select
                    onChange={event => onChange(event.target.value)}
                    style={{width: "100%"}}
                    value={filter ? filter.value : "all"}
                >
                    <option value="true">Show all</option>
                    <option value="ci">CI</option>
                    <option value="co">CO</option>
                    <option value="inv">INV</option>
                    <option value="inv/ci">INV/CI</option>
                </select>
        }, {
            Header: 'Assigned To',
            id: 'user',
            maxWidth: 150,
            accessor: d => d.user ? d.user['name'] : "unassigned",
            Cell: ({original, value}) => (
                <div>
                    {original.user ?
                        <span className={this.props.userRole === 'admin' ? "assign-user" : ""}>{value}</span> :
                        <span className={this.props.userRole === 'admin' ? "status-red assign-user" : "status-red"}>Un Assigned</span>}
                </div>
            ),
            filterable: true
        }, {
            Header: 'Submission Type',
            id: 'query_type',
            accessor: 'query_type',
            className: 'format-capitalize',
            minWidth:50,
            Cell: ({original, value}) => (
                <div>{csType[value]}

                </div>
            ),
            filterMethod: (filter, row) => {

                if (filter.value !== "") { return row[filter.id] === filter.value}
                else return true
            },
            Filter: ({filter, onChange}) =>
                <select
                    onChange={event => onChange(event.target.value)}
                    style={{width: "100%"}}
                    value={filter ? filter.value : ""}
                >
                    <option value="">Show All</option>
                    <option value="pending">Pending</option>
                    <option value="awaiting_clerk_reply">Awaiting Clerk Reply</option>
                    <option value="awaiting_admin_review">Awaiting Admin Review</option>
                    <option value="closed">Closed</option>
                </select>,

            filterable: true
            },
            {
                Header: 'Validated',
                id: 'email_validated',
                accessor: 'email_validated',
                className: 'format-capitalize',
                maxWidth:125,
                Cell: ({original, value}) => (
                    <div>{csValid[value]}
    
                    </div>
                ),
                filterMethod: (filter, row) => {
    
                    if (filter.value !== "") { return row[filter.id] === filter.value}
                    else return true
                },
                Filter: ({filter, onChange}) =>
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{width: "100%"}}
                        value={filter ? filter.value : ""}
                    >
                        <option value="">Show All</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>,
    
                filterable: true
            },{
            Header: 'Status',
            id: 'status',
            accessor: 'status',
            className: 'format-capitalize',
            maxWidth:150,
            Cell: ({original, value}) => (
                <div><Button size="mini" compact>{csStatus[value]}</Button>

                </div>
            ),
            filterMethod: (filter, row) => {

                if (filter.value !== "") { return row[filter.id] === filter.value}
                else return true
            },
            Filter: ({filter, onChange}) =>
                <select
                    onChange={event => onChange(event.target.value)}
                    style={{width: "100%"}}
                    value={filter ? filter.value : ""}>
                    <option value="">Show All</option>
                    <option value="pending">Pending</option>
                    <option value="awaiting_clerk_reply">Awaiting Clerk Reply</option>
                    <option value="awaiting_admin_review">Awaiting Admin Review</option>
                    <option value="closed">Closed</option>
                </select>,

            filterable: true
        }, {
            Header: 'Action',
            id: 'edit',
            headerClassName: 'table-actions',
            className: 'table-actions',
            accessor: 'id',
            sortable:false,
            Cell: ({original, value}) => (
                <div>
                    <Button basic compact icon positive size='mini' onClick={(e) => this.handleView(original)}><Icon
                        name='eye'/>View</Button>
                    {this.props.userRole === 'admin' && <Button basic compact icon primary size='mini' onClick={() => {
                        this.handleEdit(original)
                    }}><Icon
                        name='edit'/>Edit</Button>}
                    <Button basic compact icon color='orange' size='mini'
                                                              disabled={!(original.user && original.user.name && (original.inspection.status === 'completed' ||original.inspection.status === 'submitted' || original.inspection.status === 'processing'))}
                                                              as="a"
                                                              target="_blank"
                                                              onClick={() => {this.handleDownload(original.inspection["report_id"],original.inspection["report_filename"])} }
                    > Report <Icon
                        name='arrow right'/></Button>
        
                </div>
            )
        }];
        return (<div className="listing-container">
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={6}>
                            <Popup trigger={<Header size='large' textAlign='left' className="icon-button">Customer Service Queries</Header> }
                            content={<div className="pad-top">{this.state.dateFiltered ? <p>Queries from {moment(this.state.fromDate, "DD-MM-YYYY").format("DD-MM-YYYY")} to {moment(this.state.toDate, "DD-MM-YYYY").format("DD-MM-YYYY")}</p> : <p>Todays {moment().format("DD-MM-YYYY")} Queries</p>}
                                <Button content="Export Queries (By Date Submitted)" icon="download" labelPosition="left" onClick={() =>this.exportQueries(1)} />
                                <Button content="Export Queries (By Inspection Date)" icon="download" labelPosition="left" onClick={() =>this.exportQueries(2)} /></div>}
                                                                     header="Export"
                                                                     on='click'
                                                                     position="bottom center"
                                                                     flowing
                                                                     hideOnScroll
                                                                     wide />
                        </Grid.Column>
                        <Grid.Column width={8}>
                            {this.state.dateFiltered ?
                            <div className="center-aligned" style={{lineHeight: '2.7em'}}><span>Showing Queries from :</span><span
                                className="format-bold">{moment(this.state.fromDate).format("DD-MM-YYYY").toString()}</span><span> to </span><span
                                className="format-bold">{moment(this.state.toDate).format("DD-MM-YYYY").toString()}</span>
                            </div>:!this.state.selectiveQueries ? <div className="center-aligned" style={{lineHeight: '2.7em'}}> <span>Showing Queries for Today </span><span
                                    className="format-bold">({moment().format("DD-MM-YYYY").toString()})</span></div> : <div><span>Queries of a particular property</span>
                                </div>}
                        </Grid.Column>
                        <Grid.Column width={2} className="right-aligned">
                            <Popup
                                trigger={<Button icon='filter' labelPosition='right' content='Date'/>}
                                content={<div>
                                    <div><Header
                                        content="Filter Inspection By Date"/><Form><span><b>From: </b><DayPickerInput
                                        placeholder="From"
                                        dayPickerProps={{
                                            todayButton: 'Today',
                                            firstDayOfWeek : 1,
                                        }}
                                        format="DD-MM-YYYY"
                                        value={this.state.fromDate?this.state.fromDate:moment().format("DD-MM-YYYY")}
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        onDayChange={day => {day ? this.setState({fromDate: day,toDate:day}): this.setState({fromDate:undefined})}}/></span>
                                        <span><b>To: </b><DayPickerInput
                                            placeholder="To"
                                            format="DD-MM-YYYY"
                                            formatDate={formatDate}
                                            value={this.state.toDate}
                                            parseDate={parseDate}
                                            dayPickerProps={{
                                                disabledDays: {before: this.state.fromDate},
                                                todayButton: 'Today',
                                                firstDayOfWeek : 1,
                                            }}
                                            onDayChange={day => {day ?this.setState({toDate: day}): this.setState({endDate:undefined}) }}/></span></Form></div>
                                    <br/>
                                    <div style={{width: '100%'}} className="right-aligned"><Button
                                        content="Get Queries" primary
                                        onClick={() => this.handleFilterSelection()}/></div>
                                </div>}
                                on='click'
                                position="bottom left"
                                flowing
                                hideOnScroll
                                wide
                            />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            <div className="pad-top pad-bottom center-aligned">
                {this.state.isLoadingRefresh && <Loader contain={true} />}
                {(!this.state.dateFiltered && this.props.isFetching) && <Loader contain={true}/>}
                    {(this.state.dateFiltered && this.props.isCSDataByDateFetching) ? <Loader customText="Loading data, sit tight!" marginBottom="1000px" contain={true} /> : this.props.isListFetching ? <Loader customText={"Loading inspection data, sit tight!"} marginBottom="1000px" contain={true}/> : null}
                    {(this.props.customerServiceData || (this.props.customerServiceDataByDate)) &&
                    <ReactTable
                        data={!this.state.dateFiltered ? this.props.customerServiceData : this.props.customerServiceDataByDate}
                        columns={columns}
                        defaultFilterMethod={(filter, row, column) => {
                            const id = filter.pivotId || filter.id;
                            return row[id] !== undefined ? String(row[id]).toUpperCase().startsWith(filter.value.toUpperCase()) : true
                        }}
                        defaultPageSize={100}
                        defaultSorted={[{
                            id: 'inspection_time',
                            desc: false,
                        }, {
                            id: 'user',
                            desc: false
                        }]}
                        defaultFiltered={[{
                            id: 'status',
                            value: this.props.filterStatus ? this.props.filterStatus : ""
                        }]}
                        minRows={12}
                        style={{
                            height: '620px'
                        }}
                        noDataText="No Inspections Found in Selected range"
                        pageSizeOptions={[5, 10, 20, 25, 50, 100,200,500]}
                    />}
                <Modal size={"fullscreen"} open={this.state.action !== "listing"} closeOnDimmerClick={false} onClose={(e) => {(this.refreshData())
                    }}>
                        <Modal.Content>
                            <div className="modal-close-button">
                                <Button basic icon negative onClick={(e) => {
                                    this.refreshData()
                                }}><Icon name="close"/></Button>
                            </div>
                        <Modal.Description>
                            <Header>
                                {this.state.action === "view" && this.props.userRole === "admin" && <Button content="Edit Query" icon="edit" primary onClick={() => { this.setState({ action: "edit" }) }}></Button>}
                                {this.state.action === "edit" && this.props.userRole === "admin" && <Button content="View Query" icon="eye" primary onClick={() => { this.setState({ action: "view" }) }}></Button>}
                                  <Button icon="list" content="Report Viewer" onClick={() =>{ this.state.query.inspection.online_viewer_link && window.open(this.state.query.inspection.online_viewer_link, "_blank")}}></Button>
                                <Button icon="download" content="Report Download" onClick={() => {this.handleDownload(this.state.query.inspection["report_id"],this.state.query.inspection["report_filename"])} }></Button>
                                <Button  icon="file" content="View Inspection"  onClick={() => {
                                                            this.props.setFilter(undefined, undefined, undefined, [this.state.query.inspection_id]);
                                                            this.props.history.push('/inspection')
                                                        }}></Button>
                                 <hr/>
                                Query for {this.state.query ? this.state.query.property.address : null}
                            </Header>
                            {!this.state.refreshingQuery && <div>
                            {this.state.action === "view" && <ViewQueryDetail userRole={ this.props.userRole}refreshData={() => { this.refreshQueryData() }} query={this.state.query}></ViewQueryDetail>}
                            {this.state.action === "edit" && this.props.userRole === "admin" && <EditQueryDetail refreshData={() => { this.refreshQueryData() }} userRole={this.props.userRole}query={this.state.query}></EditQueryDetail>}</div>}
                            {this.state.refreshingQuery && <Loader contain={true}></Loader>}
                            </Modal.Description>
                        </Modal.Content>
                    </Modal>
                </div>
                {this.state.showDownload && <DownloadingIntent isDownloading={this.state.isDownloading}/>}
            </div>
        );
    }

}

export default FilterAttributes(DashboardContainer(ListingContainer(CustomerService)));


// WEBPACK FOOTER //
// ./src/views/inspection/customer_service_schedule.js